module.exports = __webpack_public_path__ + "static/img/s40.b85dac7c.png";